import TemplateView from '../../TemplateView'
import TaskStatusButton from '../../controls/task/TaskStatusButton'
import TaskStatusMenu from '../../controls/task/TaskStatusMenu'
import messageResource from '../../messageResource'
import {WorkflowStatusType} from '../../workflowStatus/constants'
import {getInstance as statusTooltip} from '../../SimpleSingletonTooltip'

export default class ChangeTaskStatusButton extends TemplateView {
    constructor({
        taskId,
        curStatusId,
        onStatusChangedCb = (id) => {},
    }) {
        super()

        this.taskId = taskId

        this.callbacks = {
            onStatusChangedCb,
        }

        this.state = {
            newStatus: {
                id: -1,
                name: '',
                type: WorkflowStatusType.COMPLETED
            },
            curStatus: {
                id: -1,
                name: '',
                type: WorkflowStatusType.COMPLETED
            },
            canBeReopened: false,
            editable: true,
        }

        this.onAnyStatePropertyDeeplyChanged(['newStatus', 'curStatus'], ({newStatus, curStatus}) => {
            this.button.setState({
                statusId: newStatus.id
            })
            this.taskStatusMenu.setState({
                showCompletedFirst: curStatus.type === WorkflowStatusType.COMPLETED,
                showReopenLabel: curStatus.type === WorkflowStatusType.COMPLETED,
            })
            this.$buttonContainer.toggleClass('modified', curStatus.id !== newStatus.id)
            this.$buttonContainer.toggleClass('completed', newStatus.type === WorkflowStatusType.COMPLETED)
        })

        this.onStatePropertyChanged('canBeReopened', (canBeReopened) => {
            this.button.setState({
                canReopenProject: canBeReopened
            })
        })

        this.onStatePropertyChanged('editable', (editable) => {
            this.button.setEditable(editable)
        })
    }

    templateHtml() {
        return '<div class="changeTaskStatusButton">' +
               '  <div class="buttonPlaceholder"></div>' +
               '</div>'
    }

    afterRender() {
        this.$buttonContainer = this.find(".buttonPlaceholder")
        this.taskStatusMenu = new TaskStatusMenu(null, {
            showActionNames: true,
        }).init(this.$el)
        this.button = new TaskStatusButton({
            hideName: true,
            taskStatusMenu: this.taskStatusMenu,
            onStatusChangedCb: this.callbacks.onStatusChangedCb,
            onShowMenu: () => {this.$buttonContainer.addClass("pressed")},
            onHideMenu: () => {this.$buttonContainer.removeClass("pressed")},
        }).init(this.$buttonContainer)

        statusTooltip().subscribeToMouseEvents(this.$buttonContainer, () => {
            statusTooltip().setState({
                html: this._getStatusTooltipHtml(this.state.newStatus.name),
                extraClass: "change_status_button_tooltip"
            })
        })
    }

    _getStatusTooltipHtml(statusName) {
        let html = '<div class="statusName">' + messageResource.getMessageWithEscapedArgs('change_status_button.tooltip.status', [statusName]) + '</div>'
        if (this.state.curStatus.id !== this.state.newStatus.id)
            html += '<div class="prevStatus">' + messageResource.getMessageWithEscapedArgs('change_status_button.changed_from', [this.state.curStatus.name]) +
                    '</div>'

        return html
    }
}



// WEBPACK FOOTER //
// ./web/js/user/entertt/ChangeTaskStatusButton.js